/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="搜索">
        <el-input size="small" v-model="formInline.username" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">确定</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" prop="username" label="用户名">
      </el-table-column>
      <el-table-column align="center" prop="accountBalance" label="余额">
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 2" type="success">管理员</el-tag>
          <el-tag v-if="scope.row.status == 1" type="warning">会员</el-tag>
          <el-tag v-if="scope.row.status == -1" type="danger">封禁</el-tag>
          <el-tag v-if="scope.row.status == 0" type="info">普通用户</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="editTime" label="修改时间" min-width="120">
        <template slot-scope="scope">
          <div>{{ scope.row.createTime | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="pay(scope.row.id)">充值</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
// 导入请求方法
import {
  userList,
  accountRecharge
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      //用户数据
      formInline: {
        username: "",
        pageNo: 1,
        pageSize: 15
      },
      userData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      }

    }
  },
  // 注册组件
  components: {
    Pagination
  },
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      // 获取用户列表
      userList(parameter).then(res => {
        this.loading = false
        this.userData = res.data.lists
        // 分页赋值
        this.pageparm.currentPage = res.data.pageNo
        this.pageparm.pageSize = res.data.pageSize
        this.pageparm.total = res.data.count
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.formInline.pageNo = 1
      this.getdata(this.formInline)
    },
    //充值
    pay(id) {
      let that = this
      this.$prompt('充值余额', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then((value) => {
        console.log(value)
        let data = {
          userId: id,
          money: value.value
        }
        accountRecharge(data).then((res) => {
          if (res.code == 200) {
            that.$message.success(res.message)
            that.search()
          } else {
            that.$message.success(res.message)
            that.search()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/system/user.vue